import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'rt-noop',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class NoopComponent {}
